import React, { Component } from 'react';
import moment from 'moment';
import API from '../../utils/API';
import DateInput from './components/DateInput';
import SaveBar from './components/SaveBar';

const formatDateForInput = (value) => {
	if (!value) return '';
	if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
	return moment.utc(value).format('YYYY-MM-DD');
};

const DEFAULT = {
	firstName: '',
	lastName: '',
	contactName: '',
	companyName: '',
	phone: '',
	title: '',
	email: '',
	signerLocation: '',
	responseDueDate: '',
	decisionDate: '',
	address: {
		country: 'US',
		state: '',
		city: '',
		zipCode: ''
	}
};

class PlannerInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: { ...DEFAULT, ...(props.request?.plannerInfo || {}), address: { ...DEFAULT.address, ...(props.request?.plannerInfo?.address || {}) } },
			editing: false,
			saving: false,
		};
	}


	formatPhoneNumber(cleanValue) {
		const countryRules = [
			{ code: '+1', regex: /^(\+1)(\d{3})(\d{3})(\d{4})$/, format: '$1 ($2) $3-$4' },
			{ code: '+7', regex: /^(\+7)(\d{3})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3-$4-$5' },
			{ code: '+27', regex: /^(\+27)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+30', regex: /^(\+30)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+31', regex: /^(\+31)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+32', regex: /^(\+32)(\d{3})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+33', regex: /^(\+33)(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5 $6' },
			{ code: '+34', regex: /^(\+34)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+351', regex: /^(\+351)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+352', regex: /^(\+352)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+353', regex: /^(\+353)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+354', regex: /^(\+354)(\d{3})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+356', regex: /^(\+356)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+358', regex: /^(\+358)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+36', regex: /^(\+36)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+370', regex: /^(\+370)(\d{3})(\d{2})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+371', regex: /^(\+371)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+372', regex: /^(\+372)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+385', regex: /^(\+385)(\d{2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+386', regex: /^(\+386)(\d{2})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+39', regex: /^(\+39)(\d{2,3})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+40', regex: /^(\+40)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+41', regex: /^(\+41)(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+420', regex: /^(\+420)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+421', regex: /^(\+421)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+43', regex: /^(\+43)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+44', regex: /^(\+44)(\d{4})(\d{6})$/, format: '$1 $2 $3' },
			{ code: '+45', regex: /^(\+45)(\d{2})(\d{2})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+46', regex: /^(\+46)(\d{2})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+47', regex: /^(\+47)(\d{3})(\d{2})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+48', regex: /^(\+48)(\d{3})(\d{3})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+49', regex: /^(\+49)(\d{2,4})(\d{4,8})$/, format: '$1 $2 $3' },
			{ code: '+52', regex: /^(\+52)(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+54', regex: /^(\+54)(\d{1})(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+55', regex: /^(\+55)(\d{2})(\d{5})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+56', regex: /^(\+56)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+57', regex: /^(\+57)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+60', regex: /^(\+60)(\d{1,2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+61', regex: /^(\+61)(\d{1})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+62', regex: /^(\+62)(\d{2,3})(\d{4,5})(\d{3,4})$/, format: '$1 $2 $3 $4' },
			{ code: '+63', regex: /^(\+63)(\d{3})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+65', regex: /^(\+65)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+81', regex: /^(\+81)(\d{2,3})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+82', regex: /^(\+82)(\d{2})(\d{4})(\d{4})$/, format: '$1 $2 $3 $4' },
			{ code: '+852', regex: /^(\+852)(\d{4})(\d{4})$/, format: '$1 $2 $3' },
			{ code: '+886', regex: /^(\+886)(\d{2})(\d{4})(\d{3})$/, format: '$1 $2 $3 $4' },
			{ code: '+90', regex: /^(\+90)(\d{3})(\d{3})(\d{2})(\d{2})$/, format: '$1 $2 $3 $4 $5' },
			{ code: '+91', regex: /^(\+91)(\d{5})(\d{5})$/, format: '$1 $2 $3' },
			{ code: '+972', regex: /^(\+972)(\d{1,2})(\d{3})(\d{4})$/, format: '$1 $2 $3 $4' },
		];

		for (const rule of countryRules) {
			if (cleanValue.startsWith(rule.code)) {
				return cleanValue.replace(rule.regex, rule.format);
			}
		}
		if (cleanValue.startsWith('+')) {
			return cleanValue.replace(/^(\+\d{1,3})(\d{1,4})(\d{3})(\d{4})$/, '$1-$2-$3-$4');
		}
		return cleanValue.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
	}

	update = (field, value) => {
		this.setState((s) => ({ data: { ...s.data, [field]: value }, editing: true }));
	};

	updateAddress = (field, value) => {
		this.setState((s) => ({
			data: { ...s.data, address: { ...s.data.address, [field]: value } },
			editing: true
		}));
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ plannerInfo: this.state.data }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving planner info:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		const p = this.props.request?.plannerInfo || {};
		this.setState({
			data: { ...DEFAULT, ...p, address: { ...DEFAULT.address, ...(p.address || {}) } },
			editing: false
		});
	};

	render() {
		const { data, editing, saving } = this.state;
		const { request } = this.props;
		const addr = data.address || {};

		return (
			<>
				{/* ── Contact Details ───────────────────────────────── */}
				<h2 className="pr-subsection-title" style={{ marginTop: 0 }}>Contract Signee</h2>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">First Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.firstName || ''}
							onChange={(e) => this.update('firstName', e.target.value)}
							placeholder="First name"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Last Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.lastName || ''}
							onChange={(e) => this.update('lastName', e.target.value)}
							placeholder="Last name"
						/>
					</div>
				</div>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">Title</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.title || ''}
							onChange={(e) => this.update('title', e.target.value)}
							placeholder="Event Manager, Director of Events…"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Company Name</label>
						<input
							className="pr-text-input"
							type="text"
							value={data.companyName || ''}
							onChange={(e) => this.update('companyName', e.target.value)}
							placeholder="Company or organization"
						/>
					</div>
				</div>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">Email</label>
						<input
							className="pr-text-input"
							type="email"
							value={data.email || ''}
							onChange={(e) => this.update('email', e.target.value)}
							placeholder="planner@company.com"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Phone</label>
						<input
						className="pr-text-input"
						type="tel"
						value={data.phone || ''}
						placeholder="(555) 123-4567"
						onChange={(e) => {
							let cleanValue = e.target.value.replace(/[^0-9+]/g, '');
							cleanValue = this.formatPhoneNumber(cleanValue);
							this.update('phone', cleanValue);
						}}
					/>
					</div>
				</div>

				<div className="pr-field-group">
					<label className="pr-field-label">Signer Location</label>
					<input
						className="pr-text-input"
						type="text"
						value={data.signerLocation || ''}
						onChange={(e) => this.update('signerLocation', e.target.value)}
						placeholder="e.g., Dallas, TX"
					/>
				</div>

				<div className="pr-row-2">
					<div className="pr-field-group compact">
						<label className="pr-field-label">Due Date</label>
						<div className="rfp-date-input-wrap">
							<DateInput
								className="rfp-date-input"
								value={formatDateForInput(data.responseDueDate)}
								allowManualInput
								onChange={(val) => this.update('responseDueDate', val || '')}
							/>
							<i className="las la-calendar rfp-date-icon" />
						</div>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Decision Date</label>
						<div className="rfp-date-input-wrap">
							<DateInput
								className="rfp-date-input"
								value={formatDateForInput(data.decisionDate)}
								allowManualInput
								onChange={(val) => this.update('decisionDate', val || '')}
							/>
							<i className="las la-calendar rfp-date-icon" />
						</div>
					</div>
				</div>

				{/* ── Address ───────────────────────────────────────── */}
				<h2 className="pr-subsection-title">Mailing Address</h2>

				<div className="pr-field-group compact">
					<label className="pr-field-label">Country</label>
					<input
						className="pr-text-input"
						type="text"
						value={addr.country || ''}
						onChange={(e) => this.updateAddress('country', e.target.value)}
						placeholder="US"
					/>
				</div>

				<div className="pr-row-3">
					<div className="pr-field-group compact">
						<label className="pr-field-label">City</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.city || ''}
							onChange={(e) => this.updateAddress('city', e.target.value)}
							placeholder="San Francisco"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">State / Province</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.state || ''}
							onChange={(e) => this.updateAddress('state', e.target.value)}
							placeholder="CA"
						/>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Zip / Postal Code</label>
						<input
							className="pr-text-input"
							type="text"
							value={addr.zipCode || ''}
							onChange={(e) => this.updateAddress('zipCode', e.target.value)}
							placeholder="94102"
						/>
					</div>
				</div>

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default PlannerInfo;
